import React, { Component } from "react";
import momLogo from "../Background/final-logo.svg";
import "./background.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PersonalInformation from "../personalInformation/PersonalInformation.jsx";
import QualificationInformation from "../qualificationInformation/QualificationInformation.jsx";
import BusinessInformation from "../businessInformation/BusinessInformation.jsx";
import ServiceInformation from "../serviceInformation/serviceInformation.jsx";
import { ToastContainer } from "react-toastify";
import {
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Form,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";

import {
  fetchAllService,
  fetchVendorInformation,
  saveServiceData,
  savePersonalData,
} from "../../Services/allServices";
import { Link, Redirect } from "react-router-dom";
import { removeToken } from "../../../auth/authenticate";
import moment from "moment";
import { config1 } from "../../config";

class Background extends Component {
  state = {
    status: "0",

    // personal Information
    profilePic: "",
    firstName: "",
    lastName: "",
    contact: "",
    emailId: "",
    dateOfBirth: "",
    gender: "",
    permanentAddress: "",
    pincode: "",
    panNumber: "",
    panDocs: "",
    isPanAvailable: "",
    adharNumber: "",
    aadharDocs: "",
    isAadharAvailable: "",
    profilePicReview: "/assets/img/avatars/profile-pic.png",
    isProfilePicChanged: false,
    addPhotoText: "Add Photo",
    // panDownload: "",
    formatDate: "yyyy-MM-dd",
    experience: "",
    selectedOption: [],
    value: [],

    // service section
    button: true,
    // may contain name with other functionality for frontend
    listOfServices: [],
    // may contain id with other functionality for sending data to backend
    listOfAvailableServices: [],
    isServiceLoading: false,
    // is form completed
    isVendorFormCompleted: false,
    isPersonalInformationCompleted: false,
    isBusinessInformationCompleted: false,
    isQualificationInformationCompleted: false,
    isServiceInformationCompleted: false,
    selectedServices: [],
  };

  // for switching the tabs
  changeHandler = (value) => {
    const {
      isPersonalInformationCompleted,
      isBusinessInformationCompleted,
      isQualificationInformationCompleted,
    } = this.state;
    if (value === "0") {
      this.setState({ status: "0" });
    } else if (value === "1" && isPersonalInformationCompleted) {
      this.setState({ status: "1" });
    } else if (
      value === "2" &&
      isQualificationInformationCompleted &&
      isPersonalInformationCompleted
    ) {
      this.setState({ status: "2" });
    } else if (
      value === "3" &&
      isBusinessInformationCompleted &&
      isQualificationInformationCompleted &&
      isPersonalInformationCompleted
    ) {
      this.setState({ status: "3" });
    }
    // this.setState({ status: value })
  };

  // for changing qualification to business page
  onChangeQualificationStatusHandler = () => {
    this.setState({
      isQualificationInformationCompleted: true,
    });
    this.changeHandler("2");
  };

  // for changing business to service page
  onChangeBusinessStatusHandler = () => {
    this.setState({
      isBusinessInformationCompleted: true,
    });
    this.changeHandler("3");
  };

  // service mode selection
  handleClick = (index, mode) => {
    let serviceArray = [...this.state.selectedServices];
    let offeredServiceArray = [...this.state.listOfAvailableServices];
    for (let i = 0; i < serviceArray.length; i++) {
      if (i === index) {
        if (mode === "Online") {
          serviceArray[i].onlineMode = !serviceArray[i].onlineMode;
          offeredServiceArray[i].onlineMode = !offeredServiceArray[i].onlineMode;
        } else if (mode === "Home") {
          serviceArray[i].homeMode = !serviceArray[i].homeMode;
          offeredServiceArray[i].homeMode = !offeredServiceArray[i].homeMode;
        } else if (mode === "Center") {
          serviceArray[i].centerMode = !serviceArray[i].centerMode;
          offeredServiceArray[i].centerMode = !offeredServiceArray[i].centerMode;
        }
      }
    }

    this.setState({
      selectedServices: serviceArray,
      listOfAvailableServices: offeredServiceArray,
    });
  };

  //select service handler

  serviceChangeHandler = (selectedServices) => {
    this.setState({ selectedServices });
  };

  // service switch handler
  // onChangeSwitchHandler = (serviceId) => {
  //   const { listOfServices, listOfAvailableServices } = this.state;
  //   // console.log('ListOfServices => ', listOfServices)
  //   let newListOfServices;

  //   newListOfServices = listOfServices.map(function (service) {
  //     if (service.value === serviceId) {
  //       service.isServiceSelected = !service.isServiceSelected;
  //       // console.log('service => -> ', service)
  //       if (service.isServiceSelected === false) {
  //         for (let i = 0; i < listOfAvailableServices.length; i++) {
  //           if (listOfAvailableServices[i].serviceId === service.value) {
  //             listOfAvailableServices[i].onlineMode = false;
  //             listOfAvailableServices[i].homeMode = false;
  //             listOfAvailableServices[i].centerMode = false;
  //           }
  //         }
  //         service.onlineMode = false;
  //         service.homeMode = false;
  //         service.centerMode = false;
  //         // console.log('false toggle => => ', service)
  //       }
  //     }
  //     return service;
  //   });

  //   // console.log('on switch => => ', newListOfServices)

  //   this.setState({
  //     listOfServices: newListOfServices,
  //     listOfAvailableServices,
  //   });
  // };

  // vendor available service submit handler
  serviceSubmitHandler = async (ev) => {
    ev.preventDefault();
    const { listOfAvailableServices, selectedServices } = this.state;
    const servicesAndModes = [];

    if (!selectedServices.length > 0) {
      return toast.error(
        "Select at Least 1 Service from the list!",
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
    } else if (
      selectedServices.find(
        (mode) => !mode.onlineMode && !mode.homeMode && !mode.centerMode
      )
    ) {
      return toast.error("Select service mode!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      for (let i = 0; i < selectedServices.length; i++) {
        let selectedService = listOfAvailableServices.find(
          (service) => service.serviceId === selectedServices[i].value
        );
        servicesAndModes.push(selectedService);

      }
    }

    const response = await saveServiceData(servicesAndModes);
    console.log('Response ----->>>> ', servicesAndModes)

    if (response.data.error === false) {
      toast.success("Services Added Successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      // removeToken();
      window.location.href = "/#/processing";
    } else {
      toast.error(
        "Error Occurred While Submitting Service Information! Please Try Again!",
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
    }
  };

  // for other state
  onChangeHandler = (e) => {
    // moment(data.dob).format("YYYY-MM-DD");
    this.setState({ [e.target.name]: e.target.value });
    // console.log(e.target.name, ' => ', e.target.value)
  };
  //multiple drop down
  handleChange = (selectedOption) => {
    // console.log(selectedOption);
    let newSelectedOptions = selectedOption.map((service) => {
      return parseInt(service.value);
    });
    this.setState({
      selectedOption: newSelectedOptions,
    });
  };
  // for reading profile pic
  readFileAsync = (file) => {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();

      reader.onload = () => {
        resolve(reader.result);
      };

      reader.onerror = reject;

      reader.readAsDataURL(file);
    });
  };

  // check MIMEType for profilePic
  checkMimeTypeForProfilePic = (ev) => {
    let imageType = ev.target.files[0].type;
    if (
      imageType === "image/png" ||
      imageType === "image/jpeg" ||
      imageType === "image/jpg" ||
      imageType === "image/mpeg"
    ) {
      return true;
    }
    return false;
  };

  // ProfilePic change handler
  profilePicChangeHandler = async (profileImgEvent) => {
    if (profileImgEvent.target.files.length > 1) {
      toast.error(`You can't upload more then 1 file`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      profileImgEvent.target.value = null;
      // console.log(profileImgEvent.target.value);
      return null;
    }

    if (this.checkMimeTypeForProfilePic(profileImgEvent)) {
      let file = profileImgEvent.target.files[0];
      let contentBuffer = await this.readFileAsync(file);
      // console.log('Content => => ', contentBuffer);
      this.setState({
        profilePic: file,
        profilePicReview: contentBuffer,
        addPhotoText: "Edit Photo",
        isProfilePicChanged: true,
      });

      // console.log(profilePicReview);

      toast.success(`ProfilePic uploaded !`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      toast.error(
        "Only png/jpg/jpeg/mpeg format are allowed! Please upload with Correct Format!",
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
    }
  };

  // check MIMEType for other Documents
  checkMimeTypeForDocuments = (event) => {
    let files = event.target.files;
    // console.log(files);
    let count = 0;
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        if (
          files[i].type === "image/png" ||
          files[i].type === "image/jpeg" ||
          files[i].type === "image/jpg" ||
          files[i].type === "image/mpeg" ||
          files[i].type === "application/pdf"
        ) {
          count++;
        } else {
          return false;
        }
      }
    }
    if (count > 0) {
      return true;
    } else {
      return false;
    }
  };

  // for AadharFileDocuments
  adharFileChangeHandler = (e) => {
    //check max 2 files are uploaded
    if (e.target.files.length > 2) {
      //show error toast
      toast.error(`You can't upload more then 2 files`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      e.target.value = null;
      return null;
    }

    if (
      this.maxSelectedFilesForAadhar(e) &&
      // this.checkFileSizeForAadharDocs(e) &&
      this.checkMimeTypeForDocuments(e)
    ) {
      let isAadharAvailable = [];
      for (let i = 0; i < e.target.files.length; i++) {
        isAadharAvailable.push(e.target.files[i].name);
      }
      this.setState({ aadharDocs: e.target.files, isAadharAvailable });
      toast.success(`Aadhar Document uploaded !`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      toast.error(
        "Only png/jpg/jpeg/mpeg/pdf format are allowed! Please upload with Correct Format!",
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
    }
  };

  // Check Size for AadharDocs
  checkFileSizeForAadharDocs = (event) => {
    let files = event.target.files;
    let size = 400000;
    let err = "";
    for (var x = 0; x < files.length; x++) {
      if (files[x].size > size) {
        err += files[x].type + "is too large, please pick a smaller file\n";
      }
    }
    if (err !== "") {
      event.target.value = null;
      //show error toast
      toast.error(`File size exceeds permissible limit`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return false;
    }

    return true;
  };

  // check maximum files for Aadhar
  maxSelectedFilesForAadhar = (event) => {
    let files = event.target.files; // create file object
    if (files.length > 3) {
      event.target.value = null; // discard selected file
      toast.error(`You can't upload more than 2 file`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return false;
    }
    return true;
  };

  // for PanFileDocuments
  panFileChangeHandler = (e) => {
    if (e.target.files.length > 2) {
      toast.error(`You can't upload more than 2 file`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      e.target.value = null;
      return null;
    }

    if (this.maxSelectedFilesForPan(e) && this.checkMimeTypeForDocuments(e)) {
      let file = e.target.files;
      this.setState({ panDocs: file, isPanAvailable: e.target.files[0].name });

      toast.success(`Pan Document uploaded !`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      toast.error(
        "Only png/jpg/jpeg/mpeg/pdf format are allowed! Please upload with Correct Format!",
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
    }
  };

  // for max file selection for pan
  maxSelectedFilesForPan = (e) => {
    let files = e.target.files;
    if (files.length > 2) {
      e.target.value = null;
      toast.error(`Only 2 image can be uploaded at a time !`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return false;
    }
    return true;
  };

  checkFileSize = (e) => {
    let files = e.target.files;
    let size = 400000;
    let err = "";
    for (var x = 0; x < files.length; x++) {
      if (files[x].size > size) {
        err += files[x].type + "is too large, please pick a smaller file\n";
      }
    }
    if (err !== "") {
      e.target.value = null;
      // console.log(err)
      // show error Message in toast
      toast.error(`File Size exceeds limit`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return false;
    }
    return true;
  };
  // for change DoB

  handleDayChange = (ev) => {
    // debugger;
    this.setState({ dateOfBirth: ev.target.value });
  };

  
  handleDayChangePer = (ev) => {
    // debugger;
    this.setState({ dateOfBirth: ev });
  };

  // personal Information submission handler
  personalInformationSubmitHandler = async (e) => {

    // debugger;
    e.preventDefault();
    const {
      firstName,
      lastName,
      contact,
      emailId,
      dateOfBirth,
      gender,
      permanentAddress,
      pincode,
      panNumber,
      adharNumber,
      aadharDocs,
      panDocs,
      profilePic,
      isProfilePicChanged,
      selectedOption,
      experience,
    } = this.state;
    //debugger;
    // convert the date into DD/MM/YYYY format
    // let dob = moment(dateOfBirth,'YYYY-MM-DD');
    // let newDate = new Date(dob);
    // console.log('newFormatDate => ', newDate)
    //calculate month difference from current date in time
    // var ageDifMs = Date.now() - newDate.getTime();
    // console.log(ageDifMs)
    //convert the calculated difference in date format
    // var ageDate = new Date(ageDifMs);
    // console.log(ageDate)
    // exact year from date and then calculate age
    // var exactDate = Math.abs(ageDate.getUTCFullYear() - 1970);
    var exactDate = moment().diff(dateOfBirth, "years");

    if (!isProfilePicChanged) {
      return toast.error("Profile Pic is Missing!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else if (selectedOption == "") {
      return toast.error("Please Select Language!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else if (exactDate > 19) {
      const data = new FormData();
      data.append("firstName", firstName);
      data.append("lastName", lastName);
      data.append("mobile", contact);
      data.append("email", emailId);
      data.append("dob", dateOfBirth);
      data.append("gender", gender);
      data.append("permanentAddress", permanentAddress);
      data.append("pinCode", pincode);
      data.append("panNumber", panNumber.toUpperCase());
      data.append("experience", experience);

      data.append("aadharCardNumber", adharNumber);

      for (var x = 0; x < aadharDocs.length; x++) {
        data.append("aadharDocs", aadharDocs[x]);
      }

      for (var y = 0; y < panDocs.length; y++) {
        data.append("panDocs", panDocs[y]);
      }
      for (var z = 0; z < selectedOption.length; z++) {
        data.append("languages", selectedOption[z]);
      }
      data.append("profilePic", profilePic);

      this.setState({ isServiceLoading: true });
      const personalResponse = await savePersonalData(data);
      console.log("personalResponse ----", personalResponse);
      this.setState({ isServiceLoading: false });

      if (personalResponse.data.error) {
        if (personalResponse.data.message.code === 11000) {
          toast.error("Aadhar or Pan Number Must be Unique!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
          });
        } else {
          toast.error("Something Went Wrong! Please Try Again!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
          });
        }
      } else {
        toast.success("Basic Details Added Successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        this.setState({ isPersonalInformationCompleted: true });
        this.changeHandler("1");
      }
    } else {
      toast.error("Minimum Age required is 20 Years!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  componentDidMount = async () => {
    this.setState({ isServiceLoading: true });
    const response = await fetchAllService();
    const vendorInformation = await fetchVendorInformation();
    // console.log('vendorInformation@@', vendorInformation)
    this.setState({ isServiceLoading: false });
    // console.log('PersonalDetailsComplete', vendorInformation)
    if (
      vendorInformation.data.personalInformation.personalDetailsComplete &&
      vendorInformation.data.businessDetails.businessDetailsComplete &&
      vendorInformation.data.educationalDetails.educationDetailsComplete &&
      vendorInformation.data.serviceDetails.vendorServiceAndModeDetailsCompleted
    ) {
      this.setState({
        isVendorFormCompleted: true,
        firstName: vendorInformation.data.personalInformation.firstName,
        lastName: vendorInformation.data.personalInformation.lastName,

        isPersonalInformationCompleted:
          vendorInformation.data.personalInformation.personalDetailsComplete,
        isBusinessInformationCompleted:
          vendorInformation.data.businessDetails.businessDetailsComplete,
        isQualificationInformationCompleted:
          vendorInformation.data.educationalDetails.educationDetailsComplete,
        isServiceInformationCompleted:
          vendorInformation.data.serviceDetails
            .vendorServiceAndModeDetailsCompleted,
      });
    } else {
      let serviceOfferedByVendor;
      if (
        vendorInformation.data.serviceDetails.servicesAndModes &&
        vendorInformation.data.serviceDetails.servicesAndModes.length > 0
      ) {
        serviceOfferedByVendor =
          vendorInformation.data.serviceDetails.servicesAndModes;
      }

      // map all the services with id and name into array of objects
      let serviceArray = response.data.data.map((nav) => {
        return {
          label: nav.name,
          value: nav._id,
          onlineMode: false,
          homeMode: false,
          centerMode: false,
        };
      });

      // filter services if vendor already offered some services
      if (serviceOfferedByVendor && serviceOfferedByVendor.length > 0) {
        for (let i = 0; i < serviceOfferedByVendor.length; i++) {
          serviceArray.find(function (service) {
            if (service.value === serviceOfferedByVendor[i].serviceId) {
              service.onlineMode = serviceOfferedByVendor[i].onlineMode;
              service.homeMode = serviceOfferedByVendor[i].homeMode;
              service.centerMode = serviceOfferedByVendor[i].centerMode;
            }
          });
        }
      }

      // Copy of List of all services
      let offeredServiceArray = response.data.data.map((nav) => {
        return {
          serviceId: nav._id,
          onlineMode: false,
          homeMode: false,
          centerMode: false,
        };
      });

      // if vendor provide any services then filter that services and particular button will be enabled or disabled
      if (serviceOfferedByVendor && serviceOfferedByVendor.length > 0) {
        for (let i = 0; i < serviceOfferedByVendor.length; i++) {
          offeredServiceArray.find(function (service) {
            if (service.serviceId === serviceOfferedByVendor[i].serviceId) {
              service.onlineMode = serviceOfferedByVendor[i].onlineMode;
              service.homeMode = serviceOfferedByVendor[i].homeMode;
              service.centerMode = serviceOfferedByVendor[i].centerMode;
            }
          });
        }
      }
      //debugger;
      // const month = new Date((vendorInformation.data.personalInformation.dob !== undefined) ? vendorInformation.data.personalInformation.dob : vendorInformation.data.createdAt).getUTCMonth() + 1;
      // const day = new Date((vendorInformation.data.personalInformation.dob !== undefined) ? vendorInformation.data.personalInformation.dob : vendorInformation.data.createdAt).getUTCDate();
      // const year = new Date((vendorInformation.data.personalInformation.dob !== undefined) ? vendorInformation.data.personalInformation.dob : vendorInformation.data.createdAt).getUTCFullYear();
      // const getDate = { day: day, month: month, year: year };
      // console.log('Personal Data => =>', getDate);
      //debugger;
      this.setState({
        //  selectedOption,
        listOfServices: serviceArray,
        listOfAvailableServices: offeredServiceArray,
        // personal information section
        firstName: vendorInformation.data.personalInformation.firstName,
        lastName: vendorInformation.data.personalInformation.lastName,
        contact: vendorInformation.data.personalInformation.mobile,
        emailId: vendorInformation.data.personalInformation.email,
        adharNumber: vendorInformation.data.personalInformation.aadharNumber,
        gender: vendorInformation.data.personalInformation.gender,
        experience: vendorInformation.data.personalInformation.experience,
        dateOfBirth:
          vendorInformation.data.personalInformation.dob !== undefined
            ? moment(vendorInformation.data.personalInformation.dob).format('DD-MM-YYYY')
            : "",
        // dateOfBirth: getDate,
        permanentAddress:
          vendorInformation.data.personalInformation.communicationAddress &&
            vendorInformation.data.personalInformation.communicationAddress
              .address !== undefined
            ? vendorInformation.data.personalInformation.communicationAddress
              .address
            : "",
        pincode:
          vendorInformation.data.personalInformation.communicationAddress &&
            vendorInformation.data.personalInformation.communicationAddress
              .pincode !== undefined
            ? vendorInformation.data.personalInformation.communicationAddress
              .pincode
            : "",
        panNumber: vendorInformation.data.personalInformation.panNumber,
        isAadharAvailable:
          vendorInformation.data.personalInformation.aadharFilePath !==
            undefined
            ? vendorInformation.data.personalInformation.aadharFilePath
            : "",
        isPanAvailable:
          vendorInformation.data.personalInformation.panFilePath !== undefined
            ? vendorInformation.data.personalInformation.panFilePath
            : "",
        profilePicReview:
          vendorInformation.data.personalInformation.profilePicFilePath !==
            undefined
            ? vendorInformation.data.personalInformation.profilePicFilePath
            : "/assets/img/avatars/profile-pic.png",
        isProfilePicChanged:
          vendorInformation.data.personalInformation.profilePicFilePath !==
            undefined
            ? true
            : false,
        isPersonalInformationCompleted:
          vendorInformation.data.personalInformation.personalDetailsComplete,
        isBusinessInformationCompleted:
          vendorInformation.data.businessDetails.businessDetailsComplete,
        isQualificationInformationCompleted:
          vendorInformation.data.educationalDetails.educationDetailsComplete,
        isServiceInformationCompleted:
          vendorInformation.data.serviceDetails
            .vendorServiceAndModeDetailsCompleted,
        selectedOption: vendorInformation.data.personalInformation.languages,
      });
      // console.log(moment(vendorInformation.data.createdAt).format('MM/DD/YYYY'));
      // console.log(vendorInformation.data.createdAt);
      // console.log(new Date(vendorInformation.data.personalInformation.dob))
      // console.log(new Date())
    }
  };
  changeHandlerLogout = (e) => {
    // var cookies = document.cookie.split(";");
    // for (var i = 0; i < cookies.length; i++) {
    //   var cookie = cookies[i];
    //   var eqPos = cookie.indexOf("=");
    //   var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    //   document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    // }
    removeToken();
    window.location.href = "/#/";
  };

  render() {
    const host = config1.API_HOST;
    const { isVendorFormCompleted, status } = this.state;
    if (isVendorFormCompleted) {
      return (
        <Redirect
          to={{
            pathname: "/processing",
          }}
        />
      );
    }
    return (
      <div
        className="app flex-row align-items-center main-container"
      // style={{ background: "#F1F5FF" }}
      >
        <ToastContainer position="bottom-center" autoClose={2000} />
        <Container>
          <Row className="mb-lg-3 mb-2 mt-5 mt-lg-0">
            <Col>
              <img src={momLogo} width="100px" height="50px" className="img-style" />
            </Col>
          </Row>
          <Row className="mt-lg-3 mt-3">
            <Col className="text-center">
              {status === "0" && <p>Personal Details</p>}
              {status === "1" && <p>Qualification Details</p>}
              {status === "2" && <p>Business Details</p>}
              {status === "3" && <p>Service Details</p>}
            </Col>
          </Row>
          <Row className="mb-3" style={{ width: "160px", margin: "auto" }}>
            <span
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                cursor: "pointer",
              }}
            >
              <div
                onClick={(e) => this.changeHandler("0")}
                style={{
                  width: "30px",
                  height: "5px",
                  borderRadius: "10px",
                  background: `${status === "0" ||
                    status === "1" ||
                    status === "2" ||
                    status === "3"
                    ? "#0059FB"
                    : "#ffff"
                    }`,
                }}
              // className={`${this.state.status === "0" ? "vendorActive" : ""}`}
              ></div>
              <div
                onClick={(e) => this.changeHandler("1")}
                style={{
                  width: "30px",
                  height: "5px",
                  borderRadius: "10px",
                  background: `${status === "1" || status === "2" || status === "3"
                    ? "#0059FB"
                    : "#ffff"
                    }`,
                }}
              // className={`${this.state.status === "1" ? "vendorActive" : ""}`}
              ></div>
              <div
                onClick={(e) => this.changeHandler("2")}
                style={{
                  width: "30px",
                  height: "5px",
                  borderRadius: "10px",
                  background: `${status === "2" || status === "3" ? "#0059FB" : "#ffff"
                    }`,
                }}
              // className={`${this.state.status === "2" ? "vendorActive" : ""}`}
              ></div>
              <div
                onClick={(e) => this.changeHandler("3")}
                style={{
                  width: "30px",
                  height: "5px",
                  borderRadius: "10px",
                  background: `${status === "3" ? "#0059FB" : "#ffff"}`,
                }}
              // className={`${this.state.status === "3" ? "vendorActive" : ""}`}
              ></div>
            </span>
          </Row>

          <Row className="justify-content-center">
            <Col md="10">
              <div className="cardHeight">
                <Row className="m-2 m-lg-0">
                  <Col
                    md="6"
                    className="pt-5 marginSpacing d-none d-md-block"
                    style={{ background: "#094184", height: "550px" }}
                  >
                    <div className="mainTitleRegister">
                      <p className="mainTitle paragraph-style">
                        Extend Quality Care On Your Schedule With Momkidcare
                      </p>
                    </div>
                    <div
                      className="mt-4"
                      style={{ display: "flex", margin: "0px 16px" }}
                    >
                      <div
                        style={{
                          // border: "1px solid black",
                          // height: "140px",
                          width: "16px",
                          marginTop: "3px",
                          // textAlign:"center",
                          // margin:"auto"
                        }}
                      >
                        <div
                          style={{
                            background: "white",
                            borderRadius: "50px",
                            height: "11px",
                            width: "11px",
                          }}
                        ></div>
                        <div
                          style={{
                            background: "white",
                            height: "6px",
                            width: "1px",
                            margin: "2px 5px auto",
                          }}
                        ></div>
                        <div
                          style={{
                            background: "white",
                            height: "6px",
                            width: "1px",
                            margin: "2px 5px auto",
                          }}
                        ></div>
                        <div
                          style={{
                            background: "white",
                            height: "6px",
                            width: "1px",
                            margin: "2px 5px auto",
                          }}
                        ></div>

                        <div
                          style={{
                            background: "white",
                            borderRadius: "50px",
                            height: "11px",
                            width: "11px",
                          }}
                        ></div>
                        <div
                          style={{
                            background: "white",
                            height: "6px",
                            width: "1px",
                            margin: "2px 5px auto",
                          }}
                        ></div>
                        <div
                          style={{
                            background: "white",
                            height: "6px",
                            width: "1px",
                            margin: "2px 5px auto",
                          }}
                        ></div>
                        <div
                          style={{
                            background: "white",
                            height: "6px",
                            width: "1px",
                            margin: "2px 5px auto",
                          }}
                        ></div>
                        <div
                          style={{
                            background: "white",
                            borderRadius: "50px",
                            height: "11px",
                            width: "11px",
                          }}
                        ></div>
                        <div
                          style={{
                            background: "white",
                            height: "6px",
                            width: "1px",
                            margin: "2px 5px auto",
                          }}
                        ></div>
                        <div
                          style={{
                            background: "white",
                            height: "6px",
                            width: "1px",
                            margin: "2px 5px auto",
                          }}
                        ></div>
                        <div
                          style={{
                            background: "white",
                            height: "6px",
                            width: "1px",
                            margin: "2px 5px auto",
                          }}
                        ></div>

                        <div
                          style={{
                            background: "white",
                            borderRadius: "50px",
                            height: "11px",
                            width: "11px",
                          }}
                        ></div>
                      </div>
                      <div
                        style={{
                          // border: "1px solid black",
                          // height: "140px",
                          width: "180px",
                          margin: "0px 7px",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "12px",
                            color: "white",

                          }}
                        >
                          Refined Enquires
                        </div>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "white",
                            margin: "17px auto",

                          }}
                        >
                          Additional Revenue Stream
                        </div>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "white",
                            margin: "17px auto",

                          }}
                        >
                          No geographical Boundaries
                        </div>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "white",
                            // marginTop: "31px",
                          }}
                        >
                          Promotional Partner
                        </div>
                      </div>
                    </div>

                    <div className="imageFixed">
                      <img
                        src="/assets/img/imgMain.png"
                        className="img-fluid img-style"
                        alt="img"
                      />
                    </div>
                  </Col>

                  <Col
                    md="6"
                    className="secondDiv"
                    style={{
                      height: "550px",
                      background: "white",
                      overflow: "auto",
                    }}
                  >
                    {this.state.status === "0" && (
                      <PersonalInformation
                        profilePic={this.state.profilePic}
                        firstName={this.state.firstName}
                        lastName={this.state.lastName}
                        contact={this.state.contact}
                        emailId={this.state.emailId}
                        dateOfBirth={this.state.dateOfBirth}
                        gender={this.state.gender}
                        permanentAddress={this.state.permanentAddress}
                        pincode={this.state.pincode}
                        panNumber={this.state.panNumber}
                        isPanAvailable={this.state.isPanAvailable}
                        adharNumber={this.state.adharNumber}
                        aadharDocs={this.state.aadharDocs}
                        profilePicReview={this.state.profilePicReview}
                        addPhotoText={this.state.addPhotoText}
                        formatDate={this.state.formatDate}
                        isServiceLoading={this.state.isServiceLoading}
                        isAadharAvailable={this.state.isAadharAvailable}
                        experience={this.state.experience}
                        handleDayChange={this.handleDayChange}
                        handleDayChangePer={this.handleDayChangePer}
                        onChangeHandler={this.onChangeHandler}
                        profilePicChangeHandler={this.profilePicChangeHandler}
                        adharFileChangeHandler={this.adharFileChangeHandler}
                        panFileChangeHandler={this.panFileChangeHandler}
                        personalInformationSubmitHandler={
                          this.personalInformationSubmitHandler
                        }
                        languageData={this.state.languageData}
                        handleChange={this.handleChange}
                        selectedOption={this.state.selectedOption}
                      />
                    )}

                    {this.state.status === "1" && (
                      <QualificationInformation
                        status={this.state.status}
                        changeHandler={this.changeHandler}
                        onChangeQualificationStatusHandler={
                          this.onChangeQualificationStatusHandler
                        }
                      />
                    )}
                    {this.state.status === "2" && (
                      <BusinessInformation
                        status={this.state.status}
                        changeHandler={this.changeHandler}
                        onChangeBusinessStatusHandler={
                          this.onChangeBusinessStatusHandler
                        }
                      />
                    )}
                    {this.state.status === "3" && (
                      <ServiceInformation
                        status={this.state.status}
                        selectedServices={this.state.selectedServices}
                        changeHandler={this.changeHandler}
                        handleClick={this.handleClick}
                        button={this.state.button}
                        listOfServices={this.state.listOfServices}
                        isServiceLoading={this.state.isServiceLoading}
                        serviceSubmitHandler={this.serviceSubmitHandler}
                        serviceChangeHandler={this.serviceChangeHandler}
                      />
                    )}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Background;
